<!-- 机构店铺设置 -->
<template>
	<div class="container">
		<div class="title">
			<div class="titleBtns" :class="current === item ? 'active' : ''" @click="handlerBtnsClick(item)"
				style="margin-right: 0.2rem" v-for="(item, index) in titleBtns" :key="index">
				{{ item }}
			</div>
		</div>
		<main class="main">
			<div class="mainBoxLeft">
				<div class="mainBoxLeftBox">
					<div class="imgBox">
						<div class="imgs">
							<ResourceUpload :showFlodNames="['公司头像']" ref="upload" ossRoute="companyImage"
								v-model="picList" :fileLimit="1" :parentId="String(datas.id)" flodName="公司头像"
								listType='picture-card'>
							</ResourceUpload>
						</div>
						<!-- <p class="p1">换一张</p> -->
					</div>
					<div class="carry">
						<p class="p1">绑定手机</p>
						<p>{{ datas.legalPhone }}</p>
					</div>
					<div class="carry">
						<p class="p1">地址</p>
						<p>{{ datas.adressRegistration }}</p>
					</div>
					<div class="carry">
						<p class="p1">成立日期</p>
						<p>{{ datas.startTime | dateFormat }}</p>
					</div>
					<div class="carry">
						<p class="p1">标语</p>
						<el-input v-model="saveDatas.slogan" size="small" placeholder="请输入内容"></el-input>
					</div>
					<div class="carry">
						<p class="p2">业务覆盖</p>
						<el-input v-model="saveDatas.countrySize" size="small"
							style="width: 0.8rem;margin-right: 0.06rem" placeholder="请输入"></el-input>
						<p style="margin-right: 0.2rem">个国家</p>
						<el-input v-model="saveDatas.citySize" size="small" style="width: 0.8rem;margin-right: 0.06rem"
							placeholder="请输入"></el-input>
						<p>个城市</p>
						<span @click="inquirySetting" class="span1">询单设置<i class="el-icon-setting"></i></span>
						<span @click="collectionSetting" class="span1">收款设置<i class="el-icon-setting"></i></span>
					</div>
					<div class="carry" style="flex-direction: column;align-items: flex-start">
						<p style="width: 1.2rem;margin-bottom: 0.2rem" class="p2">留给客户的话</p>
						<el-input v-model="saveDatas.customerMessage" type="textarea" placeholder="请输入内容" rows="5"
							show-word-limit>
						</el-input>
					</div>
					<div class="carry" style="flex-direction: column;align-items: flex-start">
						<p style="width: 1.2rem;margin-bottom: 0.2rem" class="p2">公司相册</p>
						<div class="imgs">
							<ResourceUpload :showFlodNames="['公司相册']" ref="upload1" ossRoute="companyPicture"
								v-model="picList1" :fileLimit="99" :parentId="String(datas.id)" flodName="公司相册"
								listType='picture-card'>
							</ResourceUpload>
						</div>
						<el-dialog :visible.sync="dialogVisible1">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</div>
				</div>
			</div>
			<div class="mainBoxRight">
				<div class="mainBoxRightTopBtn">
					<div @click="save" class="btns" style="margin-right: 0.24rem">
						保存
					</div>
					<div class="btns">
						返回
					</div>
				</div>
				<div class="mainBoxRightBox">
					<div class="mainBoxRightBoxTop">
						<img v-if="picList.length > 0" class="box" :src="picList[0].url">
						<img v-else class="box" src="#"></img>
						<div class="box">
							<p class="p1">{{ datas.countrySize }}</p>
							<p class="p2">国家</p>
						</div>
						<div class="box">
							<p class="p1">{{ datas.citySize }}</p>
							<p class="p2">城市</p>
						</div>
					</div>
					<div class="text1">
						{{ datas.mechanismName }} - {{ datas.slogan }}
					</div>
					<div class="text2">
						<i class="el-icon-location"></i>
						<p class="p1">{{ datas.adressRegistration }}</p>
					</div>
					<div class="text3">
						<i class="el-icon-phone"></i>
						<p class="p1">13910581028</p>
						<div class="p1" style="margin-left: auto">
							已成立{{ getYear(datas.startTime) }}年
						</div>
					</div>
					<div class="text4">
						<div class="rightBox"></div>
						<p class="p1">{{ saveDatas.customerMessage }}</p>
					</div>
					<div class="text5">
						<img class="imgs" v-for="(item, index) in picList1" :key="index" :src="item.url" alt="">
					</div>
					<div class="text6">
						<div class="textBox" v-for="(item, index) in infoDate" :key="index">
							<p class="p1">{{ item.num }}</p>
							<p class="p2">{{ item.title }}</p>
						</div>
					</div>
				</div>
			</div>
		</main>
<!--		<normsMaintain ref="normsMaintain"></normsMaintain>-->
        <normsMaintainNew ref="normsMaintainNew"></normsMaintainNew>
		<el-dialog title="询单设置" :visible.sync="centerDialogVisible" width="25%" center>
            <el-tabs @tab-click="tabClick">
                <el-tab-pane name="0" label="整团"></el-tab-pane>
                <el-tab-pane name="1" label="项目"></el-tab-pane>
            </el-tabs>
			<p style="margin-bottom: 0.1rem;"><el-checkbox
					@change="checkboxChange('autoTransfer', inquiryGearData.autoTransfer ? 0 : 1)"
					:checked="inquiryGearData.autoTransfer == 1">自动转发询单到供应商</el-checkbox></p>
			<p style="margin-bottom: 0.1rem;"><el-checkbox
					@change="checkboxChange('autoSend', inquiryGearData.autoSend ? 0 : 1)"
					:checked="inquiryGearData.autoSend == 1">收到方案之后自动发送给客户</el-checkbox></p>
			<p v-if="inquiryGearData.autoSend" style="padding-left: 0.25rem;">佣金比例%
				<el-input style="width: 1rem;" type="number" v-model="inquiryGearData.commission"
					size="mini"></el-input>
			</p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="inquiryGearSave">保 存</el-button>
			</span>
		</el-dialog>
		<el-dialog title="收款设置" :visible.sync="centerDialogVisible1" width="25%" center>
			<p style="margin-bottom: 0.1rem;"><el-radio v-model="saveDatas.paySet" :label="0">团组收款进入专项款</el-radio></p>
			<p><el-radio v-model="saveDatas.paySet" :label="1">团组收款进去公司余额</el-radio></p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="save">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Api from "@/components/Api/index.js"
import ResourceUpload from "@/components/Upload/ResourceUpload.vue";
import normsMaintain from "./child/normsMaintain.vue";
import normsMaintainNew from "@/views/mechanism/components/organizationChild/child/normsMaintainNew.vue";
export default {
	components: {
		normsMaintain,
		ResourceUpload,
        normsMaintainNew
	},
	data() {
		return {
            inquiryType:'0',
			radio:'',
			centerDialogVisible: false,
			centerDialogVisible1:false,
			//询单设置参数
			inquiryGearData: {
				autoTransfer: 0,//0 是不自动转训 1 自动转训
				autoSend: 0,//0 方案自动发送 1 不自动发送
				commission: 0,//佣金比例
			},
			picList: [],
			picList1: [],
			titleBtns: ['机构店铺页面维护', '文字说明维护', '抬头纸上传'],
			current: '机构店铺页面维护',
			dialogImageUrl: '',
			dialogVisible1: false,
			datas: {},//渲染的数据
			saveDatas: {
				slogan: null,
				countrySize: null,
				citySize: null,
				customerMessage: null,
				paySet:null
			},
			infoDate: [{
				title: '定制师',
				num: 6
			},
			{
				title: '案例',
				num: 6000
			},
			{
				title: '粉丝',
				num: 60000
			},
			{
				title: '关注',
				num: 600000
			},
			{
				title: '获赞',
				num: 60000
			}
			]
		};
	},
	computed: {},
	watch: {
        inquiryType(){
            this.inquirySetting()
        }
    },
	methods: {
        tabClick(val) {
            this.inquiryType = val.name;
        },
		mergeObjects(obj1, obj2) {
			for (let key in obj2) {
				if (obj1.hasOwnProperty(key)) {
					obj1[key] = obj2[key];
				}
			}
			return obj1;
		},
		//询单设置
		inquirySetting() {
			new Api("inquiry").inquirySetFind({inquiryType:this.inquiryType}).then((res) => {
				if (res.status === 200) {
					if (res.data) {
						this.inquiryGearData = res.data;
					}
					this.centerDialogVisible = true;
				}
			}).catch((err) => {
				this.$message({
					type: "error",
					message: '请求失败',
				});
			});
		},
		//收款设置
		collectionSetting() {
			this.centerDialogVisible1 = true
		},
		collectionGearSave() {
			this.centerDialogVisible1 = false
		},
		//询单设置保存
		inquiryGearSave() {
			this.$confirm('您确定保存该设置吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
                this.inquiryGearData.inquiryType = this.inquiryType
				new Api("inquiry").inquirySet(this.inquiryGearData).then((res) => {
					if (res.status === 200) {
						this.$message({
							type: 'success',
							message: '保存成功!'
						});
						this.centerDialogVisible = false;
					} else {
						this.$message({
							type: "error",
							message: res.statusText,
						});
					}
				}).catch((err) => {
					this.$message({
						type: "error",
						message: '保存失败！',
					});
				});
			}).catch(() => {

			});
		},
		checkboxChange(type, value) {
			this.$set(this.inquiryGearData, type, value)
		},
		//成立年份
		getYear(year) {
			const today = new Date();
			const companyEstablished = new Date(year);
			const timeDiff = today.getTime() - companyEstablished.getTime();
			const yearDiff = timeDiff / (1000 * 60 * 60 * 24 * 365);
			const years = Math.floor(yearDiff);
			return years
		},
		//保存
		save() {
			new Api("user").updateCompanyInfo(this.saveDatas).then((result) => {
				this.$refs.upload.manualUpload(this.picList, this.datas.id)
				this.$refs.upload1.manualUpload(this.picList1, this.datas.id)
				if (result.status == 200) {
					this.getCompanyInfo()
					this.$message({
						message: "保存成功",
						type: "success",
					});
				}
			}).catch((err) => {
				this.$message({
					type: "error",
					message: '保存失败',
				});
			});
		},
		getCompanyInfo() {
			new Api("user").selectCompanyInfo().then((result) => {
				if (result.status == 200) {
					this.saveDatas = this.mergeObjects(this.saveDatas, result.data)
					console.log(this.saveDatas, '看看数据8888');
					this.datas = result.data
					// this.$refs.upload.queryPics(result.data.id)
				}
			})
			// .catch((err) => {
			// 	this.$message({
			// 		type: "error",
			// 		message: '系统异常',
			// 	});
			// });
		},
		//按钮切换
		handlerBtnsClick(item, item1) {
			this.current = item
			if (item === '文字说明维护') {
				// this.$refs.normsMaintain.init(item1)
                this.$refs.normsMaintainNew.init(item1)
			} else if (item === '抬头纸上传') {
				this.$refs.normsMaintain.parentId = this.datas.id
				this.$refs.normsMaintain.current = item
				this.$refs.normsMaintain.init()
			}
		},
		handlerSelectClick(item) {
			this.dialogVisible2 = true;
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible1 = true;
		}
	},
	created() { },
	mounted() {
		this.getCompanyInfo()
		let data = this.$route.query
		if (JSON.stringify(data) !== '{}') {
			if (data.organizationIsFun) {
				this.handlerBtnsClick(data.btns, data.btns1)
			}
		}
	},
};
</script>
<style lang="scss" scoped>
/deep/ .div__label {
	text-align: left !important;
}

/deep/ .el-upload--picture-card {
	height: 1rem;
	width: 1rem;
	line-height: 1.05rem;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
	height: 1rem;
	width: 1rem;
}

.active {
	color: #CC6137 !important;
	border: 1px solid rgba(197, 59, 9, 1);
	background-color: rgba(255, 255, 255, 1);

}

.container {
	padding: 0.1rem 1.6rem 0 1.6rem;

	.imgs {
		width: 1.1rem;
		height: 1.1rem;
		margin-right: 0.1rem;
		// background-color: #FAFAFA;
		position: relative;
		overflow: hidden;
	}

	.title {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 0.1rem;

		.titleBtns {
			cursor: pointer;
			width: 5rem;
			height: 0.6rem;
			line-height: 0.6rem;
			border-radius: 0.1rem;
			font-size: 0.16rem;
			text-align: center;
			font-family: Roboto;
			background-color: rgba(255, 255, 255, 1);
			color: rgba(102, 106, 109, 1);
		}
	}

	.main {
		background-color: #fff;
		border-radius: 10px;
		padding: 0.3rem 1rem;
		display: flex;
		justify-content: space-between;

		.mainBoxLeft {
			position: relative;
			padding-top: 0.7rem;

			.mainBoxLeftBox {
				width: 6rem;
				border: 1px solid #BBBBBB;
				padding: 0.64rem 0.28rem 0.28rem 0.28rem;
				border-radius: 0.25rem;

				.carry {
					display: flex;
					align-items: center;
					margin-bottom: 0.24rem;

					.p1 {
						width: 0.8rem;
						text-align: left;
						font-weight: bold;
						color: #3A393A;
					}

					.p2 {
						width: 0.8rem;
						color: #3A393A;
					}

					.span1 {
						margin-left: 0.2rem;
						cursor: pointer;
						color: #479EC2;

						&:hover {
							text-decoration: underline;
						}
					}
				}

				.imgBox {
					display: flex;
					align-items: center;
					position: absolute;
					top: 0;
					// right: 0;
					// left: 37.5%;
					left: 50%;
					transform: translateX(-50%);

					.p1 {
						border-bottom: 1px solid rgb(187, 187, 187);
						cursor: pointer;
						color: rgb(16, 16, 16);
						font-size: 0.14rem;
					}
				}
			}
		}

		.mainBoxRight {
			min-height: 5rem;
			display: flex;
			flex-direction: column;
			align-items: center;

			.mainBoxRightTopBtn {
				display: flex;
				align-items: center;
				margin-bottom: 0.2rem;

				.btns {
					width: 1.1rem;
					height: 0.85rem;
					text-align: center;
					//padding: 0.15rem 0.15rem;
					background-color: #FF6637;
					color: white;
					font-size: 0.18rem;
					line-height: 0.85rem;
					border-radius: 0.1rem;
					//box-shadow: 0px 2px 6px 0px rgb(0 0 0 / 40%);
					cursor: pointer;
				}
			}

			.mainBoxRightBox {
				width: 3.8rem;
				padding: 0.4rem 0.18rem;
				border: 0.02rem solid #FFC2AF;
				background: white;
				border-radius: 0.1rem;

				.mainBoxRightBoxTop {
					display: flex;
					align-items: center;
					justify-content: center;
					margin-bottom: 0.24rem;

					.box {
						width: 1rem;
						height: 1rem;
						background-color: #FAFAFA;
						margin-right: 0.1rem;
						display: flex;
						align-items: center;
						flex-direction: column;
						justify-content: center;

						&:nth-last-child(1) {
							margin-right: 0;
						}

						.p1 {
							font-size: 0.3rem;
							color: #464646;
							font-weight: bold;
						}

						.p2 {
							font-size: 0.14rem;
							color: #9B9B9B;
						}
					}
				}

				.text1 {
					//margin: 20px 0px;
					font-size: 0.2rem;
					color: rgb(16, 16, 16);
					font-weight: bold;
					-webkit-font-smoothing: antialiased;
					margin-bottom: 0.24rem;
				}

				.text2 {
					display: flex;
					align-items: center;
					margin-bottom: 0.12rem;

					.el-icon-location {
						font-size: 0.24rem;
						margin-right: 0.12rem;
					}

					.p1 {
						font-size: 0.12rem;
						color: #333333;
					}
				}

				.text3 {
					display: flex;
					align-items: center;
					margin-bottom: 0.24rem;

					.el-icon-phone {
						font-size: 0.24rem;
						margin-right: 0.12rem;
					}

					.p1 {
						font-size: 0.12rem;
						color: #333333;
					}
				}

				.text4 {
					display: flex;
					align-items: center;
					margin-bottom: 0.24rem;

					.rightBox {
						width: 0.12rem;
						height: 0.4rem;
						background-color: rgb(221, 88, 39);
						margin-right: 0.24rem;
					}

					.p1 {
						font-size: 0.12rem;
						color: #333333;
					}
				}

				.text5 {
					// padding: 0.05rem 0.05rem 0.05rem 0;
					// border: 1px solid rgb(187, 187, 187);
					margin-bottom: 0.24rem;
					white-space: nowrap;
					display: flex;
					overflow-x: scroll;

				}

				.text6 {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.textBox {
						display: flex;
						align-items: center;
						flex-direction: column;

						.p1 {
							color: rgb(16, 16, 16);
							font-size: 0.21rem;
							margin-bottom: 0.05rem;
						}

						.p2 {
							color: rgba(0, 0, 0, 0.6);
							font-size: 0.12rem;
						}
					}
				}
			}
		}
	}
}
</style>
